import { JsonSchemaPianificazionePropertiesFormProperties } from "./campaign-3.model";

export class CouponPianificazioneForm{
  name: string;
  valid: boolean;
  schema: JsonSchemaPianificazionePropertiesFormProperties;
}

export class GenerazioneDropdown{
  id: string;
  code: string;
  description: string;
}

export class FruizioneDropdown{
  id: string;
  code: string;
  description: string;
}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/models/campaign-3-planning.model.ts